import { useCallback, useRef, useState } from 'react';
import { useDidUpdateEffect } from './useDidUpdateEffect';
export var useToggleFlag = function useToggleFlag(delay) {
  if (delay === void 0) {
    delay = 0;
  }

  var timerId = useRef(null);

  var _useState = useState(false),
      flag = _useState[0],
      setFlag = _useState[1];

  var toggleFlag = useCallback(function () {
    setFlag(true);
  }, []);
  useDidUpdateEffect(function () {
    if (flag) {
      timerId.current = setTimeout(function () {
        setFlag(false);
      }, delay);
      return function () {
        return clearTimeout(timerId.current);
      };
    }
  }, [flag]);
  return [flag, toggleFlag];
};